/** Кольори сегментів — спільні для «Фінансів» і «СЕС», щоб легенда читалася
 *  однаково на обох сторінках. КГУ завжди зелений; станції беруть кольори по
 *  порядку появи (янтарний, синій, фіолетовий). */
const PLANT_COLORS = ["#f59e0b", "#2563eb", "#a855f7", "#ec4899"];
const KGU_COLOR = "#10b981";

export function segmentColor(key: string, plantIndex: number): string {
  if (key === "kgu") return KGU_COLOR;
  return PLANT_COLORS[plantIndex % PLANT_COLORS.length];
}

export { KGU_COLOR, PLANT_COLORS };
